import { AdminInput, AdminToggle, AdminSelect, AdminSectionCard } from './AdminFormInput';
import ImagePicker from '@/components/ImagePicker';
import type { TemplateConfig } from '@/mocks/template-config';

interface MainImageFormProps {
  config: TemplateConfig['mainImage'];
  onChange: (config: TemplateConfig['mainImage']) => void;
}

export default function MainImageForm({ config, onChange }: MainImageFormProps) {
  const update = <K extends keyof TemplateConfig['mainImage']>(key: K, value: TemplateConfig['mainImage'][K]) => {
    onChange({ ...config, [key]: value });
  };

  return (
    <div className="space-y-5">
      <AdminSectionCard title="Imagem Principal" icon="ri-image-line">
        <ImagePicker
          label="URL da Imagem"
          value={config.image}
          onChange={(url) => update('image', url)}
          type="template"
          category="main-image"
        />
        <AdminInput
          label="Texto Alternativo"
          value={config.altText}
          onChange={(e) => update('altText', e.target.value)}
        />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <AdminSelect
            label="Posição da Imagem"
            value={config.position}
            onChange={(e) => update('position', e.target.value as 'center' | 'top' | 'bottom')}
            options={[
              { value: 'center', label: 'Centro' },
              { value: 'top', label: 'Topo' },
              { value: 'bottom', label: 'Base' },
            ]}
          />
          <div className="space-y-1.5">
            <label className="text-brand-text-muted text-xs font-medium uppercase tracking-wider">
              Intensidade do Overlay
            </label>
            <input
              type="range"
              min={0}
              max={100}
              value={config.overlayIntensity}
              onChange={(e) => update('overlayIntensity', parseInt(e.target.value, 10))}
              className="w-full accent-brand-gold"
            />
            <span className="text-brand-text-muted text-xs">{config.overlayIntensity}%</span>
          </div>
        </div>
        <AdminToggle
          label="Mostrar Caixa do Cliente"
          checked={config.showClientBox}
          onChange={(v) => update('showClientBox', v)}
        />
      </AdminSectionCard>
    </div>
  );
}